import { StandardCategory } from "../standardCategory";

/**
 * Entidad ProductCategory
 * Define las categorías de productos.
 * Soporta una estructura jerárquica (categorías y subcategorías) mediante el campo parentId.
 * Cada categoría debe estar asociada a una categoría estándar del sistema.
 */

export interface ProductCategory {
  id: string;
  accountId: string;
  parentId?: string;
  standardCategoryId: string | null;
  name: string;  // e.g., "Zapatos", "Pantalones", "Camisas"
  slug: string;
  description?: string;
  imageId?: string | null;
  order: number;
  isFeatured: boolean;
  status: ProductCategoryStatus; // ACTIVE, INACTIVE
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date | null;

  children: ProductCategory[];
  parent: ProductCategory | null;
  standardCategory: StandardCategory;
}


export enum ProductCategoryStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

